import { createSlice } from "@reduxjs/toolkit";

const deliveryInfo = createSlice({
  name: "DeliveryInfo",
  initialState: {
    door_no: "",
    address: "",
    city: "",
    state: "",
    postal_code: "",
    deliveryNote: "",
    deliveryDistance: "",
    deliveryDuration: "",
    postcodeFirstParts: [],
  
  },
  reducers: {
    setDeliveryInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
    setPostcodeFirstParts: (state, action) => {
      state.postcodeFirstParts = action.payload || [];
    },
    resetDeliveryInfo: (state) => {
      return state = {
          door_no: "",
          address: "",
          city: "",
          state: "",
          postal_code: "",
          deliveryNote: "",
          deliveryDistance: "",
          deliveryDuration: "",
          postcodeFirstParts: [],
          is_active: false,
      };
      
    },
  },
});

export const { setDeliveryInfo, setPostcodeFirstParts, resetDeliveryInfo } = deliveryInfo.actions;

export default deliveryInfo.reducer;